/** Shared formatters for the Manage Paper Trade screen. */

export function formatInr(n, { compact = false } = {}) {
  if (n == null || n === "" || Number.isNaN(Number(n))) return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: compact ? 0 : 2,
  }).format(Number(n));
}

/**
 * Session dates arrive in two shapes: a plain 'YYYY-MM-DD' (sessions synthesized from
 * the earliest buyDate) and a full ISO timestamp (sessions opened by closePaperTrade).
 * Both start with the calendar date, so read that prefix and build a *local* date from
 * its parts — `new Date("2026-06-25")` is parsed as UTC midnight and would render as
 * the 24th for anyone behind UTC.
 */
export function formatSessionDate(value) {
  if (!value) return "—";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (!match) return String(value);
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
}
